module.exports = {
  scopes: [
    'account:read', //common
    'api:iam', //dmiq
    'api:dp', //common
    'offline_access', //refresh token
    'api:asset', //dmiq - OK
    'content:read', //common
    'contact:read', //dmiq
    'dealer', //common
    'email', //common
    'equipment:read', //common
    'feedback:read', //machine
    'groups', //common
    'iot:read', //common
    'openid', //common
    'passport:read', //dmiq
    'passport:self', //common
    'product:read', //common
    'profile', //common
    'subscriptions:read', //dmiq
    'api:dms', // partsportal
    'api:partsportal', // partsportal
    'api:opc', // partsportal
    'ngpassport' // enigma
  ]
}
